import { defineStore } from 'pinia';

import { MANUSCRIPT_V1_API_URL_PREFIX as URL_PREFIX } from '@/lib/constants/manuscripts/api';
import * as action from '@/lib/constants/manuscripts/store';

const useManuscriptStore = defineStore(
  'manuscript-manuscript',

  {
    state: () => ({
      isLoading: false,
      manuscript: null,
    }),

    getters: {
      // TODO: WIP
    },

    actions: {
      async [action.DELETE_MANUSCRIPT](manuscriptId) {
        this.isLoading = true;

        const response = await this.appApi.delete(
          `${URL_PREFIX}/manuscripts/${manuscriptId}`,
        );

        this.isLoading = false;

        if (response.ok) {
          return true;
        }

        return false;
      },

      async [action.GET_MANUSCRIPT](manuscriptId) {
        this.isLoading = true;

        const response = await this.appApi(`${URL_PREFIX}/manuscripts/${manuscriptId}`);

        this.isLoading = false;

        this.manuscript = null;

        if (response.ok) {
          this.manuscript = response.data;
          return this.manuscript;
        }

        return null;
      },

      async [action.PATCH_MANUSCRIPT](manuscriptId, payload) {
        this.isLoading = true;

        const response = await this.appApi.patch(
          `${URL_PREFIX}/manuscripts/${manuscriptId}`,
          payload,
        );

        this.isLoading = false;

        if (response.ok) {
          return true;
        }

        return false;
      },

      async [action.GET_MANUSCRIPTS]() {
        this.isLoading = true;

        const response = await this.appApi(`${URL_PREFIX}/manuscripts/`);

        this.isLoading = false;

        if (response.ok) {
          return response.data;
        }

        return null;
      },
    },
  },
);

export default useManuscriptStore;
